import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { NotificationManager } from '@atlas/core';
import { DefaultPopup } from '@atlas/ui';

import { BASE_PATH } from 'common/constants';

const GPayPopup = ({ id }) => {
  const handleClose = useCallback(() => {
    NotificationManager.removeNotification(id);
  }, [id]);

  return (
    <DefaultPopup className="qr-modal" headerTitle="gpay" onClose={handleClose}>
      <div
        className="popup__content gpay"
        style={{ backgroundImage: `url("${BASE_PATH}/static/assets/images/qr-code-bg-gpay.png")` }}
      />
    </DefaultPopup>
  );
};

GPayPopup.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default GPayPopup;
